import { combineReducers } from "@reduxjs/toolkit";

import api from "@/store/api";
import appStartup from "@/store/reducers/appStartup";
import appUser from "@/store/reducers/appUser";
import attachments from "@/store/reducers/attachments";
import auth from "@/store/reducers/auth";
import booking from "@/store/reducers/booking";
import helpCenter from "@/store/reducers/helpCenter";
import login from "@/store/reducers/login";
import mfa from "@/store/reducers/mfa";
import groupClassDetailsModal from "@/store/reducers/modals/groupClassDetailsModal";
import recommendedGroupClassModal from "@/store/reducers/modals/recommendedGroupClassModal";
import scheduleEventDetailsModal from "@/store/reducers/modals/scheduleEventDetailsModal";
import taskDetailsModal from "@/store/reducers/modals/taskDetailsModal";
import waitingRoomModal from "@/store/reducers/modals/waitingRoomModal";
import notifications from "@/store/reducers/notifications";
import onboarding from "@/store/reducers/onboarding";
import smt from "@/store/reducers/smt";
import smtPhotoUpload from "@/store/reducers/smtPhotoUpload";
import toast from "@/store/reducers/toast";
import userPreferences from "@/store/reducers/userPreferences";

// eslint-disable-next-line no-restricted-syntax -- >15 properties necessary here
const rootReducer = combineReducers({
  api: api.reducer,
  appStartup,
  appUser,
  attachments,
  auth,
  booking,
  groupClassDetailsModal,
  helpCenter,
  login,
  mfa,
  notifications,
  onboarding,
  recommendedGroupClassModal,
  scheduleEventDetailsModal,
  smt,
  smtPhotoUpload,
  taskDetailsModal,
  toast,
  userPreferences,
  waitingRoomModal,
});

export default rootReducer;
